import type { ReactNode } from 'react';

export type DataPanelRowProps = {
  children?: ReactNode;
};

export function DataPanelRow({ children }: DataPanelRowProps) {
  return <div className="data-panel-row d-flex align-items-stretch bg-white gap-1">{children}</div>;
}
